import React from 'react';
import { FaHeart, FaShoppingBag, FaEye, FaStar, FaRupeeSign } from 'react-icons/fa';

const FeaturedProducts = () => {
  const products = [
    {
      id: 1,
      name: 'Premium Cotton Bedsheet',
      image: 'https://th.bing.com/th/id/R.0a348fcfe46078bd75473cec9abe2450?rik=OH4CJEaCXHrv6g&riu=http%3a%2f%2fcdn.shopify.com%2fs%2ffiles%2f1%2f0549%2f2532%2f8602%2fproducts%2f1_f4eb8e98-93f2-4c88-ab79-9537a727b8b1.jpg%3fv%3d1656052002&ehk=AlzOFG90qU6FnvmHIkB%2fRp0xWtjd4E0TysigjdEjGfk%3d&risl=&pid=ImgRaw&r=0',
      discount: '50% OFF',
      rating: 4.8,
      reviews: 124,
      category: 'Bedsheets'
    },
    {
      id: 2,
      name: 'Designer Velvet Curtains',
      image: 'https://billionfire.com/wp-content/uploads/2025/01/image-66.png',
      discount: '50% OFF',
      rating: 4.9,
      reviews: 89,
      category: 'Curtains'
    },
    {
      id: 3,
      name: 'Orthopedic Mattress',
      image: 'https://m.media-amazon.com/images/I/81HvSmy-AuL._SL1500_.jpg',
      discount: '35% OFF',
      rating: 4.7,
      reviews: 256,
      category: 'Mattresses'
    },
    {
      id: 4,
      name: 'Handwoven Persian Rug',
      image: 'https://st3.depositphotos.com/19132704/36209/i/1600/depositphotos_362094790-stock-photo-illustrated-persian-carpet-original-design.jpg',
      discount: '50% OFF',
      rating: 4.8,
      reviews: 67,
      category: 'Rugs'
    },
    {
      id: 5,
      name: 'Floral Design Wallpaper',
      image: 'https://buildingandinteriors.com/wp-content/uploads/2022/06/Living-room-wallpaper-ideas_Floral-pink-wallpaper_Sanderson.webp',
      discount: '50% OFF',
      rating: 4.6,
      reviews: 42,
      category: 'Wallpapers'
    },
    {
      id: 6,
      name: 'Ceramic Table Vase',
      image: 'https://i.pinimg.com/736x/c4/25/f1/c425f10ccc7e7a8094636cf49fc01602.jpg',
      discount: '50% OFF',
      rating: 4.5,
      reviews: 38,
      category: 'Decoratives'
    },
    {
      id: 7,
      name: 'Luxury Bath Towel Set',
      image: 'https://m.media-amazon.com/images/I/71bJz1MRXhL._AC_SX425_.jpg',
      discount: '50% OFF',
      rating: 4.9,
      reviews: 156,
      category: 'Towels'
    },
    {
      id: 8,
      name: 'Modern Table Lamp',
      image: 'https://m.media-amazon.com/images/I/813koZli4RL.jpg',
      discount: '50% OFF',
      rating: 4.7,
      reviews: 93,
      category: 'Lighting'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header with Decorative Elements */}
        <div className="text-center mb-12 relative">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-pink-500 to-blue-500 rounded-full"></div>
          <h2 className="text-3xl md:text-4xl font-bold mt-6 mb-3">
            <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent">
              Featured Products
            </span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            Discover our handpicked selection of premium home furnishings
          </p>
        </div>

        {/* Products Grid - 8 Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {products.map((product) => (
            <div 
              key={product.id} 
              className="group relative bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-pink-200"
            >
              {/* Discount Badge */}
              <div className="absolute top-3 left-3 z-10 bg-gradient-to-r from-pink-500 to-blue-500 text-white px-2 py-1 rounded-full text-xs font-semibold shadow-lg">
                {product.discount}
              </div>

              {/* Category Badge */}
              <div className="absolute top-3 right-3 z-10 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full text-xs font-semibold text-gray-700 shadow-sm">
                {product.category}
              </div>

              {/* Image Container */}
              <div className="relative h-48 overflow-hidden bg-gray-100">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://via.placeholder.com/300x200?text=Product+Image';
                  }}
                />
                
                {/* Overlay Actions */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 gap-2">
                  <button className="w-9 h-9 bg-white rounded-full flex items-center justify-center text-pink-500 hover:bg-pink-500 hover:text-white transition-all duration-300 transform hover:scale-110 shadow-lg">
                    <FaHeart size={14} />
                  </button>
                  <button className="w-9 h-9 bg-white rounded-full flex items-center justify-center text-blue-500 hover:bg-blue-500 hover:text-white transition-all duration-300 transform hover:scale-110 shadow-lg">
                    <FaShoppingBag size={14} />
                  </button>
                  <button className="w-9 h-9 bg-white rounded-full flex items-center justify-center text-purple-500 hover:bg-purple-500 hover:text-white transition-all duration-300 transform hover:scale-110 shadow-lg">
                    <FaEye size={14} />
                  </button>
                </div>
              </div>

              {/* Product Info */}
              <div className="p-4">
                <h3 className="text-base font-semibold text-gray-800 mb-1 line-clamp-1 group-hover:text-pink-500 transition-colors duration-300">
                  {product.name}
                </h3>
                
                {/* Rating */}
                <div className="flex items-center gap-1 mb-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <FaStar 
                        key={i} 
                        className={`text-xs ${i < Math.floor(product.rating) ? 'text-yellow-400' : 'text-gray-300'}`} 
                      />
                    ))}
                  </div>
                  <span className="text-xs text-gray-500">({product.reviews})</span>
                </div>

                {/* Price */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-lg font-bold text-gray-800">{product.price}</span>
                    <span className="text-xs text-gray-400 line-through">{product.oldPrice}</span>
                  </div>
                  
                  {/* Add to Cart Button - Mobile Visible */}
                  <button className="lg:hidden w-8 h-8 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300">
                    <FaShoppingBag size={12} />
                  </button>
                </div>

                {/* Add to Cart Button - Desktop Hover */}
                <button className="hidden lg:block w-full mt-3 py-2 text-xs bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-lg font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300 opacity-0 group-hover:opacity-100">
                  Add to Cart
                </button>
              </div>

              {/* Hover Border Effect */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-pink-500 rounded-xl transition-all duration-300 pointer-events-none"></div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-10">
          <button className="group relative px-6 py-2.5 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm font-semibold overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105">
            <span className="relative z-10 flex items-center gap-2">
              View All Products
              <FaShoppingBag size={14} className="group-hover:translate-x-1 transition-transform" />
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-pink-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;